// extracted by mini-css-extract-plugin
export default {"Packages":"Packages_Packages__UwKJW","PackagesBtn":"Packages_PackagesBtn__ItWGF","PackageWrapper":"Packages_PackageWrapper__E1yIn"};